import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import * as $ from 'jquery';
// import 'rxjs/add/operator/takeUntil';
import { BehaviorSubject } from 'rxjs';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-reports-menu',
  templateUrl: './reports-menu.component.html',
  styleUrls: ['./reports-menu.component.scss']
})
export class ReportsMenuComponent implements OnInit {

  searchText: string;
  baseURL: string; headers = new HttpHeaders();
  userDataa: any;
  sidenavUrl: string = "";
  isOpen: boolean = true;
  filtersTypeArray: any;

  RssoLogin : boolean = false;
  SoLogin: boolean = false;
  AbmLogin: boolean = false;
  RbmLogin: boolean = false;
  RsLogin:boolean = false;
  NsmLogin: boolean = false;
  DealerLogin: boolean = false;
  dashboardReport: boolean = false;
  
  constructor(private route: ActivatedRoute, private router: Router, private http: HttpClient) {
    let data = JSON.parse(sessionStorage.getItem('userDetails'));
    if(data.DesigId == 4) {
      this.RssoLogin = true; 
    } else if(data.DesigId == 5) {
      this.RsLogin = true;
    } else if(data.DesigId == 6) {
      this.SoLogin = true;
    } else if(data.DesigId == 7) {
      this.AbmLogin = true;
    } else if(data.DesigId == 8 ) {
      this.RbmLogin = true;
    } else if(data.DesigId == 9) {
      this.NsmLogin = true; 
    } else if(data.DesigId == 2 || data.DesigId == 3) {
      this.DealerLogin = true;
    }
  }

  ngOnInit() {
    this.sidenavUrl = this.router.url;
    if(this.sidenavUrl == '/main/reports/dashboard-report?temp=user' || this.sidenavUrl == '/main/reports/rbm-report?temp=user' || this.sidenavUrl == '/main/reports/abm-report?temp=user' || this.sidenavUrl == '/main/reports/so-report?temp=user' || this.sidenavUrl == '/main/reports/rs-report?temp=user' || this.sidenavUrl == '/main/reports/rsso-report?temp=user' || this.sidenavUrl == '/main/reports/dealer-report?temp=user' ) {
      this.dashboardReport = true;
    } else {
      this.dashboardReport = false;
    }
    this.route.queryParamMap.subscribe(queryParams => {
      const id = queryParams.get('temp');
      $("[id='" + id + "']").addClass("active");
      $("[id='icon" + id + "']").removeClass("glyphicon-plus").addClass("glyphicon-minus");
      let divHeight = $("[id='panel" + id + "']").prop('scrollHeight');
      $("[id='panel" + id + "']").css('maxHeight', divHeight + 'px');
    });
  }

  expCollapse(id, name) {
    if ($("[id='" + id + "']").hasClass("active")) {
      $("[id='" + id + "']").removeClass("active");
      $("[id='icon" + id + "']").removeClass("glyphicon-minus").addClass("glyphicon-plus");
      let divHeight = $("[id='panel" + id + "']").prop('scrollHeight');
      $("[id='panel" + id + "']").css('maxHeight', 0 + 'px');
    } else { 
      if(name  == 'web') {
        $("[id='paneluser']").css('maxHeight', 0 + 'px');
       
      }
      if(name == 'mob') {
        $("[id='paneluser-mob']").css('maxHeight', 0 + 'px');
      }
      $("[id='" + id + "']").addClass("active");
      $("[id='icon" + id + "']").removeClass("glyphicon-plus").addClass("glyphicon-minus");
      let divHeight = $("[id='panel" + id + "']").prop('scrollHeight');
      if(id == 'appmaster-mob')  {
        divHeight = divHeight + 450;
      }
      divHeight = divHeight + 200;
      $("[id='panel" + id + "']").css('maxHeight', divHeight + 'px');
    }
  }

  openDashboard() {
    if(this.NsmLogin) {
    this.router.navigate(['/main/reports/dashboard-report'], { queryParams: { temp: 'user' } });
    } else if(this.RbmLogin) {
      this.router.navigate(['/main/reports/rbm-report'], { queryParams: { temp: 'user' } });
    } else if(this.AbmLogin) {
      this.router.navigate(['/main/reports/abm-report'], { queryParams: { temp: 'user' } });
    } else if(this.RsLogin) {
      this.router.navigate(['/main/reports/rs-report'], { queryParams: { temp: 'user' } });
    }else if(this.SoLogin) {
      this.router.navigate(['/main/reports/so-report'], { queryParams: { temp: 'user' } });
    } else if(this.RssoLogin) {
      this.router.navigate(['/main/reports/rsso-report'], { queryParams: { temp: 'user' } });
    } else if(this.DealerLogin) {
      this.router.navigate(['/main/reports/dealer-report'], { queryParams: { temp: 'user' } });
    }
  }

}
